import React from 'react'

export const SignedUpContext = React.createContext({
  isSignedUp: false,
  email: '',
  signUp: () => {},
})
